import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { v4 as uuidv4 } from "uuid";
import logo from "../../assets/escudo.png";
import { Fragment, useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Avatar,
  Snackbar,
  InputAdornment,
  IconButton,
  Tooltip,
  List,
  ListItem,
  ListItemText,
  Alert,
  Grid,
  Stack,
  TextField,
  Paper,
  Chip,
  ListItemIcon,
  Divider,
  Link,
} from "@mui/material";
import { api } from "../../services/api";
import React from "react";
import RadarIcon from "@mui/icons-material/Radar";
import Loader from "../loader/loader";
import Map from "../../components/map/map";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../services/auth/AuthContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LanguageIcon from "@mui/icons-material/Language";
import SmsIcon from "@mui/icons-material/Sms";
import EmailIcon from "@mui/icons-material/Email";
import InfoIcon from "@mui/icons-material/Info";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";

import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import TodayRoundedIcon from "@mui/icons-material/TodayRounded";
import RouteRoundedIcon from "@mui/icons-material/RouteRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import {
  WEB_PUSH_KEY_NAME,
  WEB_PUSH_KEY_DEFAULT_VALUE,
} from "../../utils/const";
import type {
  CreateSubscriptionRequest,
  NotificationMethod,
  Route,
  Topic,
} from "../../types/api";

const WEEKLY_SCHEDULE: { day: string; areas: string }[] = [
  {
    day: "Lunes",
    areas: "Caldera, Tivives, Esparza Centro, Mojón, Esparzol, Granja, Tejar",
  },
  {
    day: "Martes",
    areas: "Santa Marta, Ciudadelas, Nances, Marañonal, Tres Marías, Riviera",
  },
  {
    day: "Miércoles",
    areas: "San Jerónimo, Guadalupe, San Rafael, Barón, Juanilama",
  },
  { day: "Jueves", areas: "Esparza Centro, Mojón, Esparzol, Santa Marta" },
  {
    day: "Viernes",
    areas: "Caldera, Nances, Ciudadelas, Marañonal, Tres Marías, Riviera",
  },
];

const METHOD_META: Record<
  string,
  {
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    desc: string;
    recommended?: boolean;
  }
> = {
  "3": {
    icon: <WhatsAppIcon />,
    title: "WhatsApp",
    subtitle: "Notificación por mensaje de WhatsApp",
    desc: "Recibe notificaciones por WhatsApp desde el número verificado de la Municipalidad.",
    recommended: true,
  },
  "2": {
    icon: <LanguageIcon />,
    title: "Aplicación Web",
    subtitle: "Notificaciones en tiempo real",
    desc: "Recibe alertas instantáneas directamente en tu navegador mientras tienes la aplicación abierta.",
    recommended: true,
  },
  "1": {
    icon: <SmsIcon />,
    title: "Mensaje SMS",
    subtitle: "Notificación por mensaje de texto",
    desc: "Recibe un mensaje de texto en tu teléfono móvil cuando el camión esté cerca.",
  },
  "0": {
    icon: <EmailIcon />,
    title: "Correo Electrónico",
    subtitle: "Notificación por email",
    desc: "Recibe un correo electrónico con los detalles de la ubicación del camión.",
  },
};

const steps = [
  { label: "Detalles de la ruta", subtitle: "Configuración inicial" },
  { label: "Método de notificación", subtitle: "Preferencias de alerta" },
  { label: "Revisión", subtitle: "Confirmación final" },
];

export default function HorizontalLinearStepper() {
  const navigate = useNavigate();
  const [routes, setRoutes] = useState<Route[]>([]);
  const [topics, setTopics] = useState<Topic[]>([]);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set<number>());
  const [route_id, setRoute_id]: any = useState(-1);
  const [routeType, setRouteType] = useState<"normal" | "special">("normal");
  const [notification, setNotification]: any = useState(-1);
  const [name, setName] = useState("");
  const [topicList, setTopicList]: any = useState(-1);
  const [radious, setRadious] = useState(10);
  const [geoPosition, setGeoPosition] = useState("");
  const { userAttributes, updateUser } = useAuth();
  const [listNotification, setListNotification] = useState<
    Array<string | number>
  >([]);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [userPermWebPush, setUserPermWebPush] = useState(false);

  const [shapefile, setShapefile] = useState("");
  const [notifications, setNotifications] = useState<
    Array<NotificationMethod & { active: boolean }>
  >([]);
  const [isFirstFormValid, setIsFirstFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [userLocation, setUserLocation]: any = useState({
    latitude: 9.990269053995066,
    longitude: -84.66707359259031,
  });

  const normalRoutes = routes.filter((route) => !route.is_special_recolect);
  const specialRoutes = routes.filter((route) => route.is_special_recolect);
  const selectedRoute = routes.find(
    (element: any) => String(element.id) === String(route_id),
  );

  const formatDateLabel = (value: string) => {
    const [day, month, year] = value.split("/");
    const dayNum = Number(day);
    const monthNum = Number(month);
    const yearNum = Number(year);

    if (!dayNum || !monthNum || !yearNum) {
      return value;
    }

    const parsed = new Date(Date.UTC(yearNum, monthNum - 1, dayNum));
    if (Number.isNaN(parsed.getTime())) {
      return value;
    }

    return parsed.toLocaleDateString("es-CR", {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    });
  };

  const getRouteLabel = (route?: Route) => {
    if (!route) {
      return "N/A";
    }
    if (routeType === "special") {
      return route.location || route.name;
    }
    return route.name;
  };
  // const [userLocation, setUserLocation]: any = useState({
  //   latitude: 9.93255185644459, // 9.931492332184181, //
  //   longitude: -84.09819301987451, // -84.09482172715988, //
  // });

  const RouteWeeklyScheduleCard: React.FC = () => {
    return (
      <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <CalendarMonthRoundedIcon />
          <Typography variant="subtitle1" fontWeight={700}>
            Cronograma semanal de recolección
          </Typography>
        </Stack>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 0.5, mb: 1.5 }}
        >
          Consulta los sectores atendidos por día para ayudarte a elegir la ruta
          adecuada.
        </Typography>

        <Stack spacing={1.25}>
          {WEEKLY_SCHEDULE.map((item) => (
            <Paper
              key={item.day}
              variant="outlined"
              sx={{
                p: 1.25,
                borderRadius: 1.5,
                bgcolor: "background.default",
                borderColor: "divider",
              }}
            >
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1}
                alignItems={{ sm: "center" }}
              >
                <Chip
                  label={item.day}
                  size="small"
                  color="primary"
                  variant="outlined"
                  icon={<TodayRoundedIcon />}
                  sx={{ width: { xs: "fit-content", sm: 120 } }}
                />
                <Divider
                  flexItem
                  orientation="vertical"
                  sx={{ display: { xs: "none", sm: "block" } }}
                />
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ mt: { xs: 1, sm: 0 } }}
                >
                  <RouteRoundedIcon fontSize="small" />
                  <Typography variant="body2">{item.areas}</Typography>
                </Stack>
              </Stack>
            </Paper>
          ))}
        </Stack>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 1.5 }}
        >
          * El recorrido puede ajustarse por feriados o imprevistos operativos.
        </Typography>
      </Paper>
    );
  };

  const RouteSpecialScheduleCard: React.FC<{ dates: string[] }> = ({
    dates,
  }) => {
    if (!dates || dates.length === 0) {
      return (
        <Alert severity="warning" sx={{ borderRadius: 2 }}>
          Esta ruta no tiene fechas de recolección registradas.
        </Alert>
      );
    }

    return (
      <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <CalendarMonthRoundedIcon />
          <Typography variant="subtitle1" fontWeight={700}>
            Fechas de recolección especial
          </Typography>
        </Stack>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 0.5, mb: 1.5 }}
        >
          Estas son las fechas programadas para la ruta seleccionada.
        </Typography>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {dates.map((date) => (
            <Chip
              key={date}
              label={formatDateLabel(date)}
              size="small"
              color="primary"
              variant="outlined"
            />
          ))}
        </Stack>
      </Paper>
    );
  };

  const [loadingActualPos, setLoadingActualPos] = useState(false);

  const getLocation = () => {
    setLoadingActualPos(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLoadingActualPos(false);
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (err) => {
          setLoadingActualPos(false);
          setUserLocation({
            latitude: 9.990269053995066,
            longitude: -84.66707359259031,
          });
        },
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  const handleClick = () => {
    setOpen(true);
    navigate("/");
  };

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={handleClose}>
        Cerrar
      </Button>
    </React.Fragment>
  );

  const loadTopics = async () => {
    try {
      const topics = await api.topics.getAll();
      setTopics(topics);
    } catch (error) {
      console.error("Fetching topics failed:", error);
    }
  };

  const handleChangePos = (pos: any) => {
    setUserLocation({
      latitude: pos[0],
      longitude: pos[1],
    });
    setGeoPosition(`${pos[0]}, ${pos[1]}`);
  };

  const loadRoutes = async () => {
    try {
      const routes = await api.routes.getAll();
      const isDev = process.env.NODE_ENV === "development";
      const elements = routes.filter((route) => {
        if (route.enabled === true) {
          return true;
        }
        return (
          isDev === true && route.is_dev === true && route.enabled === false
        );
      });
      setRoutes(elements);
    } catch (error) {
      console.error("Fetching routes failed:", error);
    }
  };

  const handleRouteTypeChange = (value: "normal" | "special") => {
    setRouteType(value);
    setRoute_id(-1);
    setShapefile("");
  };

  const handleAddNotifyMethod = (notification: any) => {
    setListNotification((prev: any[]) => {
      if (prev.includes(notification.id)) {
        return prev.filter((item) => item !== notification.id);
      } else {
        return [notification.id].concat(prev);
      }
    });
  };

  const positionTopicSection = () => {
    return (
      <>
        <FormControl
          className="w-2/3"
          variant="standard"
          sx={{ m: 1, minWidth: 120 }}
        >
          <InputLabel htmlFor="geographical-point-label">
            Selecciona el punto geográfico
          </InputLabel>
          <Input
            disabled
            value={`${userLocation.latitude}, ${userLocation.longitude}`}
            // onChange={(event) => setGeoPosition(event.target.value)}
            // id="geographical-point-input"
            endAdornment={
              <InputAdornment position="end">
                <RadarIcon onClick={() => getLocation()} color="success" />
              </InputAdornment>
            }
          />
        </FormControl>
        <FormControl
          className="w-2/3"
          variant="standard"
          sx={{ m: 1, minWidth: 120 }}
        >
          <InputLabel htmlFor="radiuos-point-label">
            Seleccione el radio de notificación del sistema (*Metros)
          </InputLabel>
          <Input
            value={radious}
            onChange={(event) => setRadious(parseInt(event.target.value))}
            type="number"
            id="radiuos-point-input"
          />
        </FormControl>
      </>
    );
  };

  const buildTopicActionElement = (id: string) => {
    let section = null;
    switch (id) {
      case "1": {
        section = positionTopicSection();
        break;
      }
      case "2": {
        section = <></>;
        break;
      }
      default: {
        section = positionTopicSection();
        break;
      }
    }
    return section;
  };

  const validNotificationMethodForUser = (id: string) => {
    let isValid = false;
    switch (id) {
      case "3": {
        // WA
        isValid = userAttributes?.phone_number_verified
          ? userAttributes.phone_number_verified === "true"
            ? true
            : false
          : false;
        break;
      }
      case "2": {
        isValid = userAttributes
          ? userAttributes[WEB_PUSH_KEY_NAME] === WEB_PUSH_KEY_DEFAULT_VALUE ||
            !userAttributes[WEB_PUSH_KEY_NAME]
            ? false
            : true
          : false;

        break;
      }
      case "1": {
        // SMS
        isValid = userAttributes?.phone_number_verified
          ? userAttributes.phone_number_verified === "true"
            ? true
            : false
          : false;
        break;
      }
      case "0": {
        // EMAIL
        isValid = true;
        break;
      }
      default: {
        break;
      }
    }
    return isValid;
  };

  const loadNotifications = async () => {
    try {
      const notifications = await api.notifications.getAll();
      const userValidNotifications = notifications.map((notify: any) => {
        return {
          id: notify.id,
          name: notify.name,
          active: validNotificationMethodForUser(notify.id),
        };
      });
      setNotifications(userValidNotifications);
    } catch (error) {
      console.error("Fetching notifications failed:", error);
    }
  };

  const backToHome = () => {
    navigate("/");
  };

  useEffect(() => {
    // if ("serviceWorker" in navigator) {
    //   askPermission();
    // }
    loadRoutes();
    loadNotifications();
    loadTopics();
  }, []);

  useEffect(() => {
    setIsFirstFormValid(false);

    if (
      route_id != -1 &&
      topicList != -1 &&
      userLocation != "" &&
      radious <= 10000 &&
      name != ""
    ) {
      setIsFirstFormValid(true);
    }
  }, [route_id, topicList, geoPosition, radious, name]);

  useEffect(() => {
    const findRoute: any = routes.find((element: any) => {
      return element.id.toString() === route_id.toString();
    });

    if (!findRoute) {
      setShapefile("");
      setLoadingActualPos(false);
      return;
    }

    setLoadingActualPos(true);
    const timeout = setTimeout(() => {
      setShapefile(findRoute.shapefile_url || "");
      setLoadingActualPos(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [route_id, routes]);

  const isStepOptional = (step: number) => {
    return false;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const buildDataForSubscription = (): CreateSubscriptionRequest | null => {
    const userId = userAttributes?.sub;
    if (!userId) {
      return null;
    }
    const payload: CreateSubscriptionRequest = {
      body: {
        id: uuidv4(),
        name: name,
        notifications_method: listNotification,
        route_id: route_id,
        topics: [topicList],
        user_id: userId,
        radious: radious.toString(),
        notification_point: `${userLocation.latitude}, ${userLocation.longitude}`,
      },
    };
    return payload;
  };

  const handleSubmit = async () => {
    setLoadingCreate(true);
    const payload = buildDataForSubscription();
    if (!payload) {
      setLoadingCreate(false);
      console.error("User id is missing. Unable to create subscription.");
      return;
    }
    try {
      await api.subscriptions.create(payload);
      handleClick();
    } catch (error) {
      setLoadingCreate(false);
      console.error("Error:", error);
    }
  };

  const buildRouteDetailsForm = () => {
    const availableRoutes =
      routeType === "special" ? specialRoutes : normalRoutes;
    const routeLabel =
      routeType === "special"
        ? "Seleccionar ruta de recolección de reciclaje"
        : "Seleccionar ruta";
    const selectedSpecialDates =
      selectedRoute?.notification_dates ?? selectedRoute?.days ?? [];

    return (
      <Box sx={{ width: "100%", px: { xs: 2, md: 3 }, pb: 3 }}>
        <Grid container spacing={3}>
          {/* Columna izquierda: formulario */}
          <Grid item xs={12} md={6}>
            <Typography variant="h5" fontWeight={800} gutterBottom>
              Paso 1 — Detalles de la ruta
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Define tu suscripción y selecciona el punto geográfico para
              recibir notificaciones.
            </Typography>

            <Stack spacing={2.5}>
              <TextField
                label="Nombre de la suscripción"
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <TextField
                select
                label="Tipo de ruta"
                fullWidth
                value={routeType}
                onChange={(e) =>
                  handleRouteTypeChange(e.target.value as "normal" | "special")
                }
                helperText="Selecciona si deseas una ruta normal o especial"
              >
                <MenuItem value="normal">Ruta recolección</MenuItem>
                <MenuItem value="special">
                  Ruta de recolección de reciclaje
                </MenuItem>
              </TextField>
              {/* 
              <TextField
                select
                label="Seleccionar ruta"
                fullWidth
                value={route_id}
                onChange={(e) => setRoute_id(e.target.value)}
                helperText="Cada ruta tiene horarios y frecuencias específicas"
              >
                <MenuItem value="-1">
                  <em>Ninguna</em>
                </MenuItem>
                {routes.map((r: any) => (
                  <MenuItem key={r.id} value={String(r.id)}>
                    {r.name}
                  </MenuItem>
                ))}
              </TextField> */}

              <TextField
                select
                label={routeLabel}
                fullWidth
                value={route_id}
                onChange={(e) => setRoute_id(e.target.value)}
                helperText={
                  routeType === "special"
                    ? "Las rutas especiales muestran fechas específicas de recolección"
                    : "Cada ruta tiene horarios y frecuencias específicas"
                }
              >
                <MenuItem value="-1">
                  <em>Ninguna</em>
                </MenuItem>
                {availableRoutes.map((r: any) => (
                  <MenuItem key={r.id} value={String(r.id)}>
                    {routeType === "special" ? r.location || r.name : r.name}
                  </MenuItem>
                ))}
              </TextField>

              {routeType === "normal" && <RouteWeeklyScheduleCard />}
              {routeType === "special" && route_id !== -1 && (
                <RouteSpecialScheduleCard dates={selectedSpecialDates} />
              )}

              <TextField
                select
                label="Evento a suscribir"
                fullWidth
                value={topicList}
                onChange={(e) => setTopicList(e.target.value?.toString())}
              >
                <MenuItem value="-1">
                  <em>Ninguna</em>
                </MenuItem>
                {topics.map((t: any) => (
                  <MenuItem key={t.id} value={String(t.id)}>
                    {t.name}
                    <Tooltip title={t.description} placement="right-start">
                      <InfoIcon fontSize="small" style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </MenuItem>
                ))}
              </TextField>

              {/* Coordenadas + botón "Usar ubicación actual" */}
              <Stack direction="row" spacing={1.5}>
                <TextField
                  label="Seleccionar punto geográfico"
                  value={`${userLocation.latitude.toFixed(
                    6,
                  )}, ${userLocation.longitude.toFixed(6)}`}
                  fullWidth
                  InputProps={{ readOnly: true }}
                />
                <Button
                  onClick={getLocation}
                  variant="outlined"
                  startIcon={<RadarIcon />}
                  disabled={loadingActualPos}
                  sx={{ whiteSpace: "nowrap" }}
                >
                  {loadingActualPos ? "Obteniendo..." : "Usar ubicación actual"}
                </Button>
              </Stack>

              <TextField
                select
                label="Radio de notificación (metros)"
                value={radious}
                onChange={(e) => setRadious(parseInt(e.target.value))}
                fullWidth
              >
                {[10, 100, 200, 300, 500, 800, 1000].map((m) => (
                  <MenuItem key={m} value={m}>
                    {m} metros
                  </MenuItem>
                ))}
              </TextField>

              <Alert severity="info" sx={{ mt: 0.5 }}>
                El sistema te notificará cuando un camión de esta ruta esté
                dentro del radio seleccionado.
              </Alert>

              <Box sx={{ pt: 1 }}>
                <Button
                  onClick={handleNext}
                  variant="contained"
                  size="large"
                  fullWidth
                  disabled={!isFirstFormValid}
                  endIcon={<ArrowForwardIosRoundedIcon />}
                  sx={{ textTransform: "none", py: 1.2 }}
                >
                  Siguiente
                </Button>
              </Box>
            </Stack>
          </Grid>

          {/* Columna derecha: mapa */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: { xs: 500, md: "100%" },
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 1,
              }}
            >
              {!loadingActualPos ? (
                <Map
                  height="100%"
                  selectPos
                  handleChangePos={handleChangePos}
                  initialPosition={[
                    userLocation.latitude,
                    userLocation.longitude,
                  ]}
                  radius={radious}
                  shapefileUrl={shapefile}
                  positionButtton
                  enableRealtime={false}
                />
              ) : (
                <Loader text="Cargando..." />
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const buildNotificationMethodForm = () => {
    // util para tarjeta seleccionable
    const MethodCard: React.FC<{
      method: { id: string; name: string; active: boolean };
      checked: boolean;
      onToggle: () => void;
    }> = ({ method, checked, onToggle }) => {
      const meta = METHOD_META[method.id] || {
        icon: <InfoIcon />,
        title: method.name,
        subtitle: "",
        desc: "",
      };
      const disabled = !method.active;

      return (
        <Paper
          elevation={0}
          variant="outlined"
          sx={{
            p: 2.5,
            borderRadius: 2,
            borderColor: checked ? "primary.main" : "divider",
            bgcolor: disabled ? "action.hover" : "background.paper",
            opacity: disabled ? 0.7 : 1,
          }}
        >
          <Stack direction="row" spacing={2} alignItems="flex-start">
            <Checkbox
              checked={checked}
              onChange={onToggle}
              disabled={disabled}
              sx={{ mt: 0.5 }}
            />
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: 2,
                display: "grid",
                placeItems: "center",
                bgcolor: "action.hover",
                flexShrink: 0,
              }}
            >
              {meta.icon}
            </Box>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="subtitle1" fontWeight={700}>
                  {meta.title}
                </Typography>
                {meta.recommended && (
                  <Chip
                    size="small"
                    label="Recomendado"
                    color="success"
                    variant="filled"
                  />
                )}
              </Stack>
              {meta.subtitle && (
                <Typography variant="body2" color="text.secondary">
                  {meta.subtitle}
                </Typography>
              )}
              {meta.desc && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {meta.desc}
                </Typography>
              )}

              {!method.active && (
                <Tooltip
                  title="Para usar este método necesitas activar el permiso en tu perfil."
                  placement="right-start"
                >
                  <InfoIcon
                    fontSize="small"
                    color="action"
                    style={{ marginTop: 8 }}
                  />
                </Tooltip>
              )}
            </Box>
          </Stack>
        </Paper>
      );
    };

    return (
      <Box sx={{ width: "100%", px: { xs: 2, md: 3 }, pb: 3 }}>
        <Grid container spacing={3}>
          {/* Columna izquierda */}
          <Grid item xs={12} md={6}>
            <Typography variant="h5" fontWeight={800} gutterBottom>
              Paso 2 — Método de notificación
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Selecciona cómo quieres recibir las alertas cuando el camión esté
              cerca de tu ubicación.
            </Typography>

            <Stack spacing={2}>
              {/* Tarjetas mapeadas desde tu API */}
              {notifications.map((m: any) => {
                const checked =
                  listNotification.find((id: any) => id === m.id) !== undefined;

                return (
                  <MethodCard
                    key={m.id}
                    method={m}
                    checked={checked}
                    onToggle={() => handleAddNotifyMethod(m)}
                  />
                );
              })}
            </Stack>

            {/* (Opcional) Frecuencia de notificaciones - placeholder visual */}
            {/* <Box sx={{ mt: 3 }}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ mb: 1 }}
              >
                Frecuencia de notificaciones
              </Typography>
              <Typography variant="body2" color="text.disabled">
                (Próximamente) Configura si deseas recibir cada alerta o un
                resumen.
              </Typography>
            </Box> */}

            {/* Botones */}
            <Stack
              direction="row"
              spacing={2}
              sx={{ mt: 3 }}
              justifyContent="flex-start"
            >
              <Button
                onClick={handleBack}
                variant="text"
                startIcon={<ArrowBackIosNewRoundedIcon />}
                sx={{ textTransform: "none" }}
              >
                Atrás
              </Button>
              <Button
                variant="contained"
                onClick={handleNext}
                disabled={listNotification.length === 0}
                endIcon={<ArrowForwardIosRoundedIcon />}
                sx={{ textTransform: "none" }}
              >
                Siguiente
              </Button>
            </Stack>
          </Grid>

          {/* Columna derecha: mapa */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: { xs: 360, md: 600 },
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 1,
              }}
            >
              <Map
                height="100%"
                selectPos={false}
                initialPosition={[
                  userLocation.latitude,
                  userLocation.longitude,
                ]}
                radius={radious}
                shapefileUrl={shapefile}
                positionButtton
                enableRealtime={false}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const buildReviewSection = () => {
    // obtener nombres desde tus listas existentes
    const route: any = routes.find(
      (r: any) => r.id.toString() === route_id.toString(),
    );
    const topic: any = topics.find(
      (t: any) => t.id.toString() === topicList?.toString(),
    );
    const topicName = topic?.name || "N/A";
    const routeName = getRouteLabel(route);
    const routeTypeLabel =
      routeType === "special" ? "Especial (reciclaje)" : "Normal";
    const specialDates = route?.notification_dates ?? route?.days ?? [];

    const mapElement: Record<string, { label: string; icon: React.ReactNode }> =
      {
        "0": { label: "Correo Electrónico", icon: <EmailIcon /> },
        "1": { label: "SMS", icon: <SmsIcon /> },
        "2": { label: "Aplicación Web", icon: <LanguageIcon /> },
        "3": { label: "WhatsApp", icon: <WhatsAppIcon /> },
      };
    const selectedNotifications = listNotification.map((id) => {
      const idStr = String(id);
      const meta = mapElement[idStr] || {
        label: idStr,
        icon: <InfoIcon />,
      };
      return {
        id: idStr,
        ...meta,
      };
    });

    return (
      <Box sx={{ width: "100%", px: { xs: 2, md: 3 }, pb: 3 }}>
        <Grid container spacing={3}>
          {/* Panel izquierdo */}
          <Grid item xs={12} md={6}>
            <Typography variant="h5" fontWeight={800} gutterBottom>
              Paso 3 — Revisión
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Revisa tu configuración antes de crear la suscripción. Podrás
              modificar estos ajustes más tarde desde tu panel principal.
            </Typography>

            {/* --- Detalles de la ruta --- */}
            <Paper variant="outlined" sx={{ p: 2.5, mb: 2.5, borderRadius: 2 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="subtitle1" fontWeight={700}>
                  Detalles de la ruta
                </Typography>
                <Button
                  size="small"
                  color="primary"
                  startIcon={<EditRoundedIcon fontSize="small" />}
                  onClick={() => setActiveStep(0)}
                >
                  Editar
                </Button>
              </Stack>

              <Box sx={{ mt: 1 }}>
                <Typography variant="body2">
                  <strong>Nombre:</strong> {name}
                </Typography>
                <Typography variant="body2">
                  <strong>Tipo de ruta:</strong> {routeTypeLabel}
                </Typography>
                <Typography variant="body2">
                  <strong>Ruta:</strong> {routeName}
                </Typography>
                {routeType === "special" && (
                  <Typography variant="body2">
                    <strong>Fechas de recolección:</strong>{" "}
                    {specialDates.length > 0
                      ? specialDates.map(formatDateLabel).join(", ")
                      : "Sin fechas registradas"}
                  </Typography>
                )}
                <Typography variant="body2">
                  <strong>Evento:</strong> {topicName}
                </Typography>
                <Typography variant="body2">
                  <strong>Ubicación:</strong> {userLocation.latitude.toFixed(4)}
                  , {userLocation.longitude.toFixed(4)}
                </Typography>
                <Typography variant="body2">
                  <strong>Radio de notificación:</strong> {radious} metros
                </Typography>
              </Box>
            </Paper>

            {/* --- Métodos de notificación --- */}
            <Paper variant="outlined" sx={{ p: 2.5, mb: 2.5, borderRadius: 2 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="subtitle1" fontWeight={700}>
                  Métodos de notificación
                </Typography>
                <Button
                  size="small"
                  color="primary"
                  startIcon={<EditRoundedIcon fontSize="small" />}
                  onClick={() => setActiveStep(1)}
                >
                  Editar
                </Button>
              </Stack>

              <List dense>
                {selectedNotifications.map((n: any) => (
                  <ListItem key={n.id} sx={{ py: 0.5 }}>
                    <ListItemIcon>{n.icon}</ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="body2" fontWeight={600}>
                          {n.label}
                        </Typography>
                      }
                      secondary="Notificaciones activas"
                    />
                    <CheckCircleRoundedIcon color="success" fontSize="small" />
                  </ListItem>
                ))}

                {/* Si hay métodos inactivos */}
                {["0", "1", "2", "3"]
                  .filter(
                    (id) =>
                      !selectedNotifications.find((s: any) => s.id === id),
                  )
                  .map((id) => (
                    <ListItem
                      key={`inactive-${id}`}
                      sx={{ py: 0.5, opacity: 0.6 }}
                    >
                      <ListItemIcon>{mapElement[id].icon}</ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography variant="body2">
                            {mapElement[id].label}
                          </Typography>
                        }
                        secondary="No configurado"
                      />
                    </ListItem>
                  ))}
              </List>

              <Divider sx={{ my: 1.5 }} />
              <Typography variant="body2">
                <strong>Frecuencia:</strong> Inmediata
              </Typography>
            </Paper>

            {/* --- Qué esperar --- */}
            <Alert
              icon={<InfoIcon />}
              severity="info"
              sx={{
                borderRadius: 2,
                alignItems: "flex-start",
                "& .MuiAlert-message": { width: "100%" },
              }}
            >
              <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                ¿Qué esperar?
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Recibirás notificaciones cuando un camión de la ruta{" "}
                <strong>{routeName}</strong> esté dentro de {radious} m de tu
                ubicación.
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Las alertas se enviarán inmediatamente por los métodos
                seleccionados.
              </Typography>
              <Typography variant="body2">
                Puedes pausar, modificar o eliminar esta suscripción en
                cualquier momento.
              </Typography>
            </Alert>

            {/* --- Botones --- */}
            <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
              <Button
                onClick={handleBack}
                variant="text"
                startIcon={<ArrowBackIosNewRoundedIcon />}
                sx={{ textTransform: "none" }}
              >
                Anterior
              </Button>
              <Button
                onClick={handleSubmit}
                variant="contained"
                color="success"
                startIcon={<DoneAllRoundedIcon />}
                disabled={loadingCreate}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  bgcolor: "#16A34A",
                  "&:hover": { bgcolor: "#15803D" },
                }}
              >
                {loadingCreate ? "Creando..." : "Crear suscripción"}
              </Button>
            </Stack>

            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 2 }}
            >
              Al crear esta suscripción aceptas recibir notificaciones según la
              configuración establecida.{" "}
              <Link href="#" color="primary" underline="hover">
                Términos y condiciones
              </Link>
            </Typography>
          </Grid>

          {/* --- Mapa a la derecha --- */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: { xs: 360, md: 600 },
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: 1,
              }}
            >
              <Map
                height="100%"
                selectPos={false}
                initialPosition={[
                  userLocation.latitude,
                  userLocation.longitude,
                ]}
                radius={radious}
                shapefileUrl={shapefile}
                positionButtton
                enableRealtime={false}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ padding: 2 }} elevation={0}>
        <Box
          sx={{
            px: { xs: 2, md: 3 },
            pt: 1,
            pb: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={backToHome}
            startIcon={<ArrowBackIcon />}
            variant="text"
            sx={{ textTransform: "none" }}
          >
            Volver al panel principal
          </Button>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Avatar sx={{ width: 28, height: 28 }}>
              {(userAttributes?.given_name?.[0] || "B").toUpperCase()}
            </Avatar>
            <Typography variant="body2">
              {userAttributes?.given_name || "Bryan"}
            </Typography>
          </Box>
        </Box>
      </Paper>
      <Divider />
      <Paper sx={{ padding: 2 }} elevation={0}>
        <Stepper
          activeStep={activeStep}
          sx={{ px: { xs: 2, md: 3 }, pt: 1, pb: 2 }}
        >
          {steps.map((s, index) => (
            <Step key={s.label}>
              <StepLabel
                optional={
                  <Typography variant="caption" color="text.secondary">
                    {s.subtitle}
                  </Typography>
                }
              >
                {s.label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Paper>
      <Divider />
      {activeStep === steps.length ? (
        <Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        </Fragment>
      ) : (
        <Fragment>
          <div
            style={{ width: "100%", padding: "2em" }}
            className="flex justify-center justify-items-center items-center h-1/2"
          >
            {activeStep === 0 && buildRouteDetailsForm()}
            {activeStep === 1 && buildNotificationMethodForm()}
            {activeStep === 2 && buildReviewSection()}
          </div>

          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
            message="Elemento creado correctamente"
            action={action}
          />
        </Fragment>
      )}
    </Box>
  );
}
